// These events don't go to Segment.io, but do go to MixPanel (or whatever replaces it)
export enum NonSegmentEvents {
  ApplicationLoaded = 'Application Loaded',
  AssetSelected = 'Asset Selected',
  CheckBoxChanged = 'Checkbox Changed',
  ConfigMissingBackPage = 'Config Missing Back Page',
  CreatedPayByLinkCommunication = 'Created Pay By Link Communication',
  CustomerAlreadyEnrolled = 'Customer Is Already Enrolled',
  CustomerActionFlowStarted = 'Customer Action Flow Started',
  CustomerActionFlowCompleted = 'Customer Action Flow Completed',
  CustomerIsEligible = 'Customer Is Eligible',
  DeviceConfirmed = 'Device Confirmed',
  DeviceIncorrect = 'Device Incorrect',
  DeviceIneligible = 'Device Ineligible',
  EnrollmentFlowReset = 'Enrollment Flow Reset',
  EnrollmentSuccess = 'Enrollment Success',
  ErrorAuthorizingPayment = 'Error Authorizing Payment',
  ErrorCreatingBillingAddress = 'Error Creating Billing Address',
  ErrorCreatingCustomerSession = 'Error Creating Customer Session',
  ErrorCreatingEnrollment = 'Error Creating Enrollment',
  ErrorCreatingPaySession = 'Error Creating Pay Session',
  ErrorCreatingProductOffer = 'Error Creating Product Offer',
  ErrorDeletingProductOfferWhileNavigatingBack = 'Error Deleting Product Offer While Navigating Back',
  ErrorEnrollingCustomer = 'Error Enrolling Customer',
  ErrorFormValidation = 'Error Form Validation',
  ErrorInitializingCustomerActionFlowSession = 'Error Initializing Customer Action Flow Session',
  ErrorMakingSalesForceCallback = 'Error Making Salesforce Callback',
  ErrorSendingDay0Link = 'Error Sending Day 0 link',
  ErrorSendingPayByLink = 'Error Sending PayByLink',
  ErrorSettingBillingFrequencyInMonths = 'Error Setting Billing Frequency In Months',
  ErrorUpdatingBillingAddress = 'Error Updating Billing Address',
  ErrorUpdatingCustomer = 'Error Updating Customer',
  ErrorUpdatingPaySession = 'Error Updating Pay Session',
  ErrorPageViewed = 'Error Page Viewed',
  ErrorWithRecaptcha = 'Error With Recaptcha',
  ExternalLinkClicked = 'External Link Clicked',
  GotQuestionsClicked = 'Got Questions Clicked',
  HomeLinkClicked = 'Home Link Clicked',
  InitialPageLoad = 'Initial Page Load',
  IneligiblePageViewed = 'Ineligible Page Viewed',
  LegalDisclosuresAccepted = 'Legal Disclosures Accepted',
  LegalDisclosuresDeclined = 'Legal Disclosures Declined',
  LinkClicked = 'Link Clicked',
  MaxPaySessionsExceeded = 'Max Pay Sessions Exceeded',
  MdnVerificationCreated = 'Mdn Verification Created',
  MyDashboardLinkClicked = 'My Dashboard Link Clicked',
  OTPVerificationFailed = 'OTP Verification Failed',
  OTPVerificationSuccessful = 'OTP Verification Successful',
  PayByLinkCommunicationPreferenceSelected = 'Pay By Link Communication Preference Selected',
  PayAndEnrollStepUpdated = 'Pay and Enroll Step Updated',
  PaySessionFailureStatusReturned = 'Pay Session Failure Status Returned',
  PendingBillingTokenReloaded = 'Pending Billing Token Reloaded',
  PendingEnrollmentReloaded = 'Pending Enrollment Reloaded',
  PendingPaymentAuthReloaded = 'Pending Payment Auth Reloaded',
  RadioSelected = 'Radio Selected Option',
  RecaptchaCompleted = 'Recaptcha Completed',
  ResendOTPClicked = 'Resend OTP Clicked',
  RoutePathChanged = 'RoutePathChanged',
  SmsOptIn = 'SMS Opt In Accepted',
  SalesForceCallbackSuccess = 'Sales Force callback Success',
  SaveAndFinishLinkClicked = 'Save And Finish Link Clicked',
}

export function isNonSegmentEvent(event: string): event is NonSegmentEvents {
  return Object.values<string>(NonSegmentEvents).includes(event);
}
